import React from 'react';

import { formatPrice, } from 'common/functions';
import Typography from '@material-ui/core/Typography';

type Props = {
    price: number,
};

const ProductsItemPrice: React.FC<Props> = ({ price, }) => (
    <Typography variant="h4">
        {formatPrice(price)}
    </Typography>
);

export default ProductsItemPrice;
